import { MAX_TILE_COUNT } from '../../mineGame.constants'
import { useLocation } from 'react-router-dom'
import GongaMineBomb from '../../images/bomb-mine.png'
import GongaMineGem from '../../images/mine-open.png'
import './FairnessMineTable.scss'

const tiles = Array.from({ length: MAX_TILE_COUNT }, (_, i) => i + 1)

const MineFairnessModalResult = ({ mines }) => {
  const { search } = useLocation()
  const gameId = new URLSearchParams(search).get('gameId')

  const displayNormalPlayBoard = (tile) => {
    if (mines?.includes(tile)) {
      return <img src={GongaMineBomb} alt='Bomb' />
    } else {
      return <img src={GongaMineGem} alt='Star' />
    }
  }

  return (
    <div className='mine-fairness-game-table'>
      <div className='mine-body'>
        {tiles.map((tile) => {
          return (
            <button key={`tiles-${tile}`} className='mines text-center rotateY'>
              <div
                className='mine-grid-box gonga-mine-bet-locked-img'
              >
                {mines && displayNormalPlayBoard(tile)}
              </div>
            </button>
          )
        })}
      </div>
    </div>
  )
}

export default MineFairnessModalResult
